import React from 'react';


export const EventCircle = React.memo(
    ({
        color, radius = 8, style,
    }: {
        color: string;
        radius?: number;
        style?: React.CSSProperties;
    }) => {
        return (
            <div
                style={{
                    ...style,
                    width: radius,
                    height: radius,
                    borderRadius: '50%',
                    backgroundColor: color,
                }} />
        );
    }
);
